import { render, staticRenderFns } from "./WhitePageLayout.vue?vue&type=template&id=3088d885&scoped=true&"
import script from "./WhitePageLayout.vue?vue&type=script&lang=js&"
export * from "./WhitePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./WhitePageLayout.vue?vue&type=style&index=0&id=3088d885&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3088d885",
  null
  
)

export default component.exports